var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-spinner',{staticClass:"multi-select-loading-spinner",attrs:{"small":"","label":"Loading Data..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }